import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IGetItemsResult } from '~src/httpClient/serverApi/types/IGetItemsResult';

import { IContentRelayPlan } from '../types/IContentRelayPlan';

/**
 * Parameters for the VizPortal `listPlans` Web Client method. These map to the
 * `@PayloadParameter` names on WebClientContentMobilityAppService.listPlans in the monolith
 * (state / pageSize / pageToken) — note it is token-paged, not offset-paged.
 */
export interface IGetContentRelayPlansParams {
  state?: string;
  pageSize?: number;
  pageToken?: string;
}

export interface IGetContentRelayPlansResult extends IGetItemsResult {
  plans?: IContentRelayPlan[];
}

export class GetContentRelayPlansRequest extends Request<IGetContentRelayPlansParams, IGetContentRelayPlansResult> {
  constructor(params: IGetContentRelayPlansParams) {
    super('listPlans', params);
  }
}
